import {
  createBaseAsyncReducer,
  createFailAction,
  createKeyedAsyncReducer,
  createStartAction,
  createSuccessAction,
  initialState,
} from '../../../redux-util/async-helpers';
import { createReducer } from '../../../redux-util/general-helpers';
import { LIST_ALL_USERS } from '../../bridge-method-remap';

const baseListReducer = createBaseAsyncReducer(LIST_ALL_USERS, data => {
  const users = data.users
    // Sometimes bridge gives us users with no id. They should fix this, but let's not crash the page if it happens.
    .filter(u => !!u.id)
    .map(d => d.id);
  return {
    ...data,
    users,
  };
});

const listHandlers = {
  [createSuccessAction(LIST_ALL_USERS).type]: (state, action) => {
    const result = baseListReducer(state, action);
    if (state.data) {
      result.data.users = [...state.data.users, ...result.data.users];
    }
    return result;
  },
  [createFailAction(LIST_ALL_USERS).type]: (state, action) => {
    return baseListReducer(state, action);
  },
  [createStartAction(LIST_ALL_USERS).type]: (state, action) => {
    return baseListReducer(state, action);
  },
};

export default createKeyedAsyncReducer({
  actionKeys: LIST_ALL_USERS,
  param: 'group',
  itemReducer: createReducer(initialState, listHandlers),
});



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/groups/users/reducer.js